import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActiveIngredientService } from '../../../active-ingredient.service';
import {
  ACTIVE_INGREDIENT_TTL_ES,
  IActiveIngredient,
  IActiveIngredientUpdate
} from '../../../active-ingredient.interface';
import { UpdateTemplate } from 'src/app/@amiga-pyme/crud/templates/update/update.template';
import { IUpdateTemplate } from 'src/app/@amiga-pyme/crud/templates/update/update.interface';

@Component({
  selector: 'pg-active-ingredient-update',
  templateUrl: './active-ingredient-update.component.html'
})
export class ActiveIngredientUpdateComponent
  extends UpdateTemplate
  implements IUpdateTemplate
{
  constructor(
    private fb: FormBuilder,
    private serviceBase: ActiveIngredientService
  ) {
    super(ACTIVE_INGREDIENT_TTL_ES, serviceBase);
  }

  ngOnInit() {
    const item = this.row as IActiveIngredient;
    this.fg = this.fb.group({
      description: [
        item?.description,
        [
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(255)
        ]
      ]
    });
  }

  onSubmit() {
    this.updateItem$(this.fg.value as IActiveIngredientUpdate);
  }
}
